import {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

import {
    doc,
    onSnapshot,
} from "firebase/firestore";

import { db } from "../firebase";
import { CLUB_ID } from "../config/club";
import { updateClubConfig } from "../config/club";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {

    // 🔥 CLUB SETTINGS
    const [clubSettings, setClubSettings] = useState(null);

    // 🔥 DARK MODE
    const [darkMode, setDarkMode] = useState(
        localStorage.getItem("darkMode") === "true"
    );

    const loadingClub = clubSettings === null;

    const clubId = CLUB_ID;

    // 🔥 LIVE CLUB SETTINGS
    useEffect(() => {

        const unsub = onSnapshot(
            doc(db, "clubs", clubId),
            (snapshot) => {

                if (snapshot.exists()) {
                    setClubSettings(snapshot.data());
                    updateClubConfig(snapshot.data());
                }
            }
        );

        return () => unsub();

    }, []);
    
    // 🔥 APPLY THEME
    useEffect(() => {

        const theme = darkMode ? "dark" : "light";

        document.documentElement.setAttribute(
            "data-bs-theme",
            theme
        );

        localStorage.setItem(
            "darkMode",
            darkMode
        );

        // 🔥 DYNAMIC BRAND COLOR
        document.documentElement.style.setProperty(
            "--brand-color",
            clubSettings?.themeColor || "#591094"
        );

    }, [darkMode, clubSettings]);

    return (
        <ThemeContext.Provider
            value={{
                darkMode,
                setDarkMode,

                clubSettings,
                setClubSettings,

                loadingClub,
            }}
        >
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);